module.exports = __webpack_public_path__ + "media/application/images/capterra-shortlist-badge-46a986521c1ab26d2de990a8ea7a41ca.png";